import { SkeletonRectangle } from '@leagueplatform/genesis-core';

import React, { forwardRef } from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { Props } from './types';

export const LargeSkeleton = forwardRef<HTMLDivElement, Props>(
  ({ ...props }, ref) => (
    <SkeletonRectangle
      ref={ref}
      height={{
        '@initial': '196px',
        '@tablet': '220px',
        '@mobileLandscape': '220px',
        '@mobile': '396px',
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  ),
);

export type LargeSkeletonWSNode = MasonryEngineNode<'loadingLarge', Props>;

export const LargeSkeletonWSRenderer = ({
  rootElementRef,
  ...props
}: MasonryEngineNodeRendererProps<LargeSkeletonWSNode>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <LargeSkeleton ref={rootElementRef} {...props} />
);
